import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import CustomButton from "../constant/commonButton";

const DeleteDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>Are you sure you want to delete this row?</DialogContent>
      <DialogActions>
        <CustomButton
          text="Cancel"
          size="XtraSmall"
          onClick={onClose}
          buttonStyle="style3"
        />
        <CustomButton
          text="Ok"
          size="XtraSmall"
          onClick={onConfirm}
          buttonStyle="StyledButton"
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
